import { render, staticRenderFns } from "./ComponentMaterialInput.vue?vue&type=template&id=2d911878&scoped=true&"
import script from "./ComponentMaterialInput.vue?vue&type=script&lang=js&"
export * from "./ComponentMaterialInput.vue?vue&type=script&lang=js&"
import style0 from "./ComponentMaterialInput.vue?vue&type=style&index=0&id=2d911878&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d911878",
  null
  
)

export default component.exports